import { Action } from "../../models/Action";
import { getConfigurationFacility } from "./configActions";

declare const config: { FACILITY_IDS: string };
export const FACILITY_IDS = (config && config.FACILITY_IDS) || "";

export interface ConfigState {
  facilityIds: string;
  facilityLogoUrl: string;
}

const initialConfig: ConfigState = {
  facilityIds: FACILITY_IDS,
  facilityLogoUrl: "",
};

export default function configReducer(authState = initialConfig, action: Action<any>) {
  switch (action.type) {
    case getConfigurationFacility.fulfilled.toString():
      return {
        ...authState,
        facilityLogoUrl: action.payload.logoUrl,
      };
    default:
      return authState;
  }
}
